import { PieChartCard } from '@/components';
import { useGetChartColorsAndLabel } from '@/hooks';
import { useGetProcess } from '@/modules/Processes/queries';
import { useTranslation } from 'react-i18next';

type ProcessTimeDistributionCardProps = {
  processId: number;
};

export const ProcessTimeDistributionCard = ({
  processId,
}: ProcessTimeDistributionCardProps) => {
  const { t } = useTranslation();

  const { data: process } = useGetProcess(processId);

  const { processTimeDistributionChart } = useGetChartColorsAndLabel();

  return (
    <>
      <PieChartCard
        data={[
          {
            name: processTimeDistributionChart.manualTime.name,
            fill: processTimeDistributionChart.manualTime.fill,
            value: process?.manualTime ?? 0,
          },
          {
            name: processTimeDistributionChart.automatedTime.name,
            fill: processTimeDistributionChart.automatedTime.fill,
            value: process?.automatedTime ?? 0,
          },
        ]}
        chartTitle={t('process_time_distribution')}
        valueType="percentage"
        subtitle={t('total')}
        convert={true}
      />
    </>
  );
};
